import { render } from "./FormEditTeacher.vue?vue&type=template&id=53f31fd0&scoped=true"
import script from "./FormEditTeacher.vue?vue&type=script&lang=js"
export * from "./FormEditTeacher.vue?vue&type=script&lang=js"

import "./FormEditTeacher.vue?vue&type=style&index=0&id=53f31fd0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f31fd0"]])

export default __exports__